<div class="accordion" id="filterAccordion" *ngIf="filterForm">
  <div class="accordion-item">
    <h2 class="accordion-header" id="headingOne">
      <button
        class="accordion-button"
        type="button"
        data-toggle="collapse"
        data-target="#collapseOne"
        aria-expanded="true"
        aria-controls="collapseOne"
      >
        <div class="filter-icon-text">
          <i class="fa fa-filter" aria-hidden="true" style="float: left"></i>
          <span style="float: left; margin-left: 10px">Filter</span>
        </div>
        <i class="fa fa-chevron-down" aria-hidden="true"></i>
      </button>
    </h2>
    <div
      id="collapseOne"
      class="accordion-collapse collapse hide"
      aria-labelledby="headingOne"
      data-parent="#filterAccordion"
    >
      <div class="accordion-body" cdkDrag>
        <form [formGroup]="filterForm">
          <ng-container *ngFor="let control of formConfig">
            <ng-container [ngSwitch]="control.inputType">
              <!-- For Input type as a text -->
              <ng-container *ngSwitchCase="'text'">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">{{
                    control.title
                  }}</label>
                  <input
                    type="text"
                    class="form-control"
                    id="exampleFormControlInput1"
                    [placeholder]="control.title"
                    formControlName="{{ control.controlName }}"
                  />
                </div>
              </ng-container>

              <!-- For input type as dropdown -->
              <ng-container *ngSwitchCase="'dropdown'">
                <label for="">{{ control.title }}</label>
                <select
                  class="form-select"
                  name=""
                  formControlName="{{ control.controlName }}"
                >
                  <ng-container *ngFor="let option of control.options">
                    <option [value]="option">{{ option }}</option>
                  </ng-container>
                </select>
              </ng-container>

              <ng-container *ngSwitchCase="'dropdownIds'">
                <label for="{{ control.controlName }}">{{
                  control.title
                }}</label>
                <select
                  class="form-select"
                  name=""
                  formControlName="{{ control.controlName }}"
                  style="width: 100%"
                >
                  <option [ngValue]="null" selected>--Please Select--</option>
                  <ng-container *ngFor="let option of control.dropdownOptions">
                    <option [value]="option?.id">{{ option?.desc }}</option>
                  </ng-container>
                </select>
              </ng-container>

              <!-- For Input type as checkbox -->
              <ng-container *ngSwitchCase="'checkbox'">
                <label>{{ control.title }}</label>
                <div class="row check-form">
                  <div
                    class="col-md-12"
                    *ngFor="let option of control?.checkboxOptions"
                    style="margin: 5px"
                  >
                    <div class="form-check">
                      <input
                        #checkboxes
                        class="form-check-input"
                        type="checkbox"
                        (change)="
                          onCheckboxChange($event, option, control.controlName)
                        "
                      />
                      <label class="form-check-label">
                        {{ option.desc }}
                      </label>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- For Input type as radio -->
              <ng-container *ngSwitchCase="'radio'">
                <label>{{ control.title }}</label>
                <div class="row check-form">
                  <div
                    class="col-md-12"
                    *ngFor="let option of control?.radioOptions | keyvalue"
                    style="margin: 5px"
                  >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        [value]="option.key"
                        formControlName="{{ control.controlName }}"
                      />
                      <label class="form-check-label">
                        {{ option.value }}
                      </label>
                    </div>
                  </div>
                </div>
              </ng-container>

              <!-- For Input type as multi select -->
              <ng-container *ngSwitchCase="'multiselect'">
                <label>{{ control.title }}</label>
                <div class="check-form">
                  <ng-container *ngFor="let option of control?.options">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [name]="$any(control).controlName"
                        (change)="
                          onCheckboxChange(
                            $event,
                            option.value,
                            control.controlName
                          )
                        "
                      />
                      <label class="form-check-label">
                        {{ option.viewValue }}
                      </label>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'date'">
                <label>{{ control.title }}</label>
                <div class="mb-3">
                  <input
                    type="date"
                    formControlName="{{ control.controlName }}"
                    class="form-control"
                    [maxDate]="minDate | date : 'dd/MM/yyyy'"
                    placeholder="Select Date"
                    
                  />
                </div>
              </ng-container>

              <!-- For Input type as Range Date -->
              <div class="container">
                <div class="row">
                  <ng-container *ngSwitchCase="'rangeDate'">
                    <div class="col">
                      <label>{{ control.labelFrom }}</label>
                      <input
                        type="date"
                        formControlName="{{ $any(control).startControlName }}"
                        class="form-control"
                        [max]="
                          (this.filterForm.get($any(control).startControlName)
                            ?.value
                            ? this.filterForm.get(
                                $any(control).startControlName
                              )?.value
                            : this.minDate
                          ) | date : 'yyyy-MM-dd'
                        "
                        placeholder="Select Date"
                      />
                    </div>
                    <div class="col">
                      <label>{{ control.labelTo }}</label>
                      <input
                        type="date"
                        formControlName="{{ $any(control).endControlName }}"
                        class="form-control"
                        [min]="
                          filterForm.get($any(control).startControlName)?.value
                        "
                        placeholder="Select Date"
                      />
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <div class="row justify-content-center">
            <!-- <div class="col-md-6">
							<button type="button" (click)="resetFilter()" data-toggle="collapse"
								data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
								class="btn fltr-btn_outline"
								[ngClass]="{'active': filterForm.dirty, 'disabled':!filterForm.dirty}">
								Reset
							</button>
						</div> -->
            <form class="form-inline my-2 my-lg-0">
              <button
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                (click)="resetFilter()"
                class="btn reset-btn"
              >
                Reset Filter
              </button>
              <button
                type="button"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
                (click)="submitForm()"
                class="btn fltr-btn"
              >
                Apply Filter
              </button>
            </form>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
